import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../../hooks/useTheme.js';
import { SkipLink } from '../../Link/SkipLink/index.js';
import { useMainNavContext } from '../MainNavContext/index.js';

var MainNavSkipLink = function (_a) {
    _a.children; var props = __rest(_a, ["children"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var themeKey = useMainNavContext().themeKey;
    var forwardProps = handleStyleProps(props, {
        themeKey: "".concat(themeKey, "SkipLink"),
    });
    return (jsx(SkipLink, __assign({ href: "#main", themeKey: "".concat(themeKey, "Item"), "data-skip-link": true, "data-current": true }, forwardProps, { children: "Skip to content" })));
};
MainNavSkipLink.displayName = "MainNavSkipLink";

export { MainNavSkipLink };
//# sourceMappingURL=index.js.map
